import loadImage from "blueimp-load-image";

export const onImageUpload = (fileList, setIdCard) => {
  // 이미지 파일 데이터
  const file = fileList[0];
  // 추가된 코드
  // 1. 이미지 로드
  loadImage(
    file,
    function (img, data) {
      // 2. 이미지 파일 데이터에 imageHead와 exif가 있는지 확인
      if (data.imageHead && data.exif) {
        // 3. exif 값이 있다면 orientation 값을 1로 변경
        loadImage.writeExifData(data.imageHead, data, "Orientation", 1);
        img.toBlob(function (blob) {
          loadImage.replaceHead(blob, data.imageHead, async function (newBlob) {
            newBlob.name = file.name;
            // 4. 기존 메서드로 파일 s3에 업로드
            await previewImg(newBlob, newBlob.name + ".jpg", setIdCard);
          });
        }, "image/jpeg");
      } else {
        // exif 값 없으면 바로 s3에 업로드
        previewImg(file, file.name + ".jpg", setIdCard);
      }
    },
    { meta: true, orientation: true, canvas: true }
  );
};

const previewImg = (file, fileName, setIdCard) => {
  const reader = new FileReader();

  reader.readAsDataURL(file);

  return new Promise(resolve => {
    reader.onload = e => {
      setIdCard({ file: reader.result, fileName: fileName });
      resolve();
    };
  });
};
